import debug, { Debugger } from "debug";

const appLogger = debug("antai-docs-frontend");

export default appLogger;

export function useLogger(loggerNamespace: string): { log: Debugger } {
  const log = appLogger.extend(loggerNamespace);
  return {
    log,
  };
}
